// extracted by mini-css-extract-plugin
export default {"Link":"PullRequestLink-module__Link--i17X3"};